import { create } from 'zustand';

import {
  ReanalyzeStatus,
  TemplateDetectionStatus,
  type TemplateDTO,
} from '@/types/filterItems';

type State = {
  reanalyzeStatus: ReanalyzeStatus;
  templateDetectionStatus: TemplateDetectionStatus;
  detectedTemplates: TemplateDTO[];
};

type Actions = {
  startReanalyze: () => void;
  setReanalyzeStatus: (status: ReanalyzeStatus) => void;
  setTemplateDetectionStatus: (status: TemplateDetectionStatus) => void;
  setTemplateDetection: (
    status: TemplateDetectionStatus,
    templates: TemplateDTO[],
  ) => void;
  setDetectedTemplates: (templates: TemplateDTO[]) => void;
  deleteDetectedTemplate: (index: number) => void;
  clearDetectedTemplates: () => void;
  startTemplateDetection: () => void;
};

const initialState: State = {
  reanalyzeStatus: ReanalyzeStatus.REANALYZE_STATUS_COMPLETE,
  templateDetectionStatus:
    TemplateDetectionStatus.TEMPLATE_DETECTION_STATUS_COMPLETE,
  detectedTemplates: [],
};

const useFilterItemsStore = create<State & Actions>((set, get) => ({
  ...initialState,

  startReanalyze: () => {
    set({
      reanalyzeStatus: ReanalyzeStatus.REANALYZE_STATUS_RUNNING,
    });
  },

  setReanalyzeStatus: (status: ReanalyzeStatus) => {
    set({
      reanalyzeStatus: status,
    });
  },

  startTemplateDetection: () => {
    get().setTemplateDetectionStatus(
      TemplateDetectionStatus.TEMPLATE_DETECTION_STATUS_RUNNING,
    );
    get().clearDetectedTemplates();
  },

  setTemplateDetectionStatus: (status: TemplateDetectionStatus) => {
    set({
      templateDetectionStatus: status,
    });
  },

  setTemplateDetection: (
    status: TemplateDetectionStatus,
    templates: TemplateDTO[],
  ) => {
    get().setTemplateDetectionStatus(status);
    get().setDetectedTemplates(templates);
  },

  setDetectedTemplates: (templates: TemplateDTO[]) => {
    set({
      detectedTemplates: templates,
    });
  },

  deleteDetectedTemplate: (index: number) => {
    set((state) => {
      return {
        detectedTemplates: state.detectedTemplates.filter(
          (_, i) => i !== index,
        ),
      };
    });
  },

  clearDetectedTemplates: () => {
    set({
      detectedTemplates: [],
    });
  },
}));

export default useFilterItemsStore;
